import styled from 'styled-components';

import { Button } from '@atom/button/button';

export const ForgotLink = styled(Button)`
  padding: 0;
`;
